// Keep behavior aligned with the shared search-term privacy fixtures.
export const validSearchTerm = (value: unknown): value is string =>
  typeof value === "string" &&
  value.length > 0 &&
  Array.from(value).length <= 80 &&
  value === value.normalize("NFC").toLowerCase() &&
  value === value.trim().split(/\s+/u).join(" ") &&
  /^[\p{L}\p{M}0-9 -]+$/u.test(value) &&
  /\p{L}/u.test(value) &&
  (value.match(/[0-9]/gu) || []).length <= 3 &&
  !value.includes("http") &&
  !value.includes("www");
